import _isNil from "lodash/isNil";
var getTaskWorkerState = function getTaskWorkerState(experimentBackendStatus, taskName) {
  var _worker$progress;
  var _ref = experimentBackendStatus !== null && experimentBackendStatus !== void 0 ? experimentBackendStatus : {},
    _ref$workerStatus = _ref.workerStatus,
    workerStatus = _ref$workerStatus === void 0 ? {} : _ref$workerStatus,
    _ref$taskWorkers = _ref.taskWorkers,
    taskWorkers = _ref$taskWorkers === void 0 ? {} : _ref$taskWorkers;
  if (!(taskName in taskWorkers)) return null;
  var worker = workerStatus[taskWorkers[taskName]];

  // A request was submitted and the worker hasn't sent a heartbeat since - it's still
  // spinning up.
  if (_isNil(worker) || _isNil(worker.statusCode)) return {
    provisioning: true
  };

  // Idle: nothing to report.
  if (_isNil(worker.userMessage)) return null;
  return {
    userMessage: worker.userMessage,
    progress: (_worker$progress = worker.progress) !== null && _worker$progress !== void 0 ? _worker$progress : null
  };
};
export default getTaskWorkerState;